import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoPlusLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 7C13.4477 7 13 7.44772 13 8V13H8C7.44772 13 7 13.4477 7 14V16C7 16.5523 7.44772 17 8 17H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V17H22C22.5523 17 23 16.5523 23 16V14C23 13.4477 22.5523 13 22 13H17V8C17 7.44772 16.5523 7 16 7H14Z"
	})]
});
const ForwardRef = forwardRef(SvgIcoPlusLink);
export { ForwardRef as ReactComponent };
